import { getLocalTimeZone, today } from '@internationalized/date';

export function getCurrentDate(timeZone: string = getLocalTimeZone()) {
  return today(timeZone);
}
